import React from 'react';
import {Button, Icon, Modal} from "semantic-ui-react";
import PropTypes from "prop-types";
import cx from "classnames";
import { translate } from "@flow-frontend-npm/common";

import styles from "./ImportantInfoModal.scss";
import t from "./translations";

/**
 * Renders the modal.
 * @param {object} props
 * @return {*}
 * @constructor
 */
const ImportantInfoModal = ({ open = false, infos, handleClose = () => {}}) => {
    return (<Modal open={open && infosAreAvailable(infos)}
        onClose={handleClose} className={styles.ImportantInfoModal}
    >
        <Modal.Header>{translate(t, 'importantInfoTitle')}</Modal.Header>
        <Modal.Content><ul className={cx(styles.info)}>{
            (infos !== null && infos !== undefined) ? infos.filter(info => !!info).map(info => renderInfo(info)) : ""
        }</ul></Modal.Content>
        <Modal.Actions>
            <Button color='green' onClick={handleClose}><Icon name='checkmark'/>OK</Button>
        </Modal.Actions>
    </Modal>);
};

export const INFO_PROP_TYPE = PropTypes.shape({
    text: PropTypes.string.isRequired,
    emphasis: PropTypes.oneOf(['NONE', 'NORMAL', 'STRONG', 'VERY_STRONG']).isRequired,
    recentlyChanged: PropTypes.bool.isRequired,
    srcType: PropTypes.string.isRequired,
    srcId: PropTypes.number.isRequired,
    srcName: PropTypes.string
});

ImportantInfoModal.displayName = 'ImportantInfoModal';

ImportantInfoModal.propTypes = {
    open: PropTypes.bool,
    infos: PropTypes.arrayOf(INFO_PROP_TYPE),
    handleClose: PropTypes.func
};

/**
 * @param {Array} infos
 * @return {boolean}
 */
const infosAreAvailable = (infos) => !!infos && !!infos.length && infos.some(info => !!info);

/**
 * @param {object} info
 * @return {*}
 */
const renderInfo = info => (
    <li key={info.srcType + '-' + info.srcId} title={info.srcName} className={cx(
        {[styles['recently-changed']]: info.recentlyChanged},
        styles[info.emphasis]
    )}>{info.text}</li>
);

export default ImportantInfoModal;
